import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type ExternalModuleList as SchemaExternalModuleList } from '../schemas/ExternalModuleList';
import { type GetLastExternalModuleRequest as SchemaGetLastExternalModuleRequest } from '../schemas/GetLastExternalModuleRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetLastExternalModulesContentType = 'application/json' as const;
export type GetLastExternalModulesRequest = SchemaGetLastExternalModuleRequest;
export type GetLastExternalModulesResponses = LinkCommonErrorResponses & {
    /**
     * @description External modules list
     */
    '200': {
        'application/json': SchemaExternalModuleList;
    };
};
export type GetLastExternalModulesResponseSuccess = GetLastExternalModulesResponses['200']['application/json'];
export type GetLastExternalModulesSearchParams = undefined;
export type GetLastExternalModulesPathParameters = undefined;
export const GetLastExternalModulesUrl = '/external_modules/last' as const;
export const GetLastExternalModulesMethod = 'POST' as const;
export const getGetLastExternalModulesUrl = (_params?: GetLastExternalModulesPathParameters) =>
    GetLastExternalModulesUrl;
